import { MilesToMeters } from "@swivl/swivl-lib";

export function MetersToMiles(meters:number):number {
    switch (meters) {
      case MilesToMeters.Miles_1   : return 1; 
      case MilesToMeters.Miles_5   : return 5; 
      case MilesToMeters.Miles_10  : return 10; 
      case MilesToMeters.Miles_15  : return 15; 
      case MilesToMeters.Miles_25  : return 25;
      case MilesToMeters.Miles_50  : return 50;
      case MilesToMeters.Miles_100 : return 100; 
      default: 
        return Math.round( meters / MilesToMeters.Miles_1);
     }
  
  }